import { DeliveryOptionService } from './delivery-option.service';
import { AngularFirestore, AngularFirestoreCollection, DocumentReference } from '@angular/fire/firestore';
import { CurrencyPipe } from '@angular/common';
import { FirebaseDaoBase } from '../table/daos/firebase-dao-base';
import { DeliveryOption } from './DeliveryOption';

export class DeliveryOptionDao extends FirebaseDaoBase<any> {


  constructor(public deliveryOptionService: DeliveryOptionService) {
    super();
  }

  public getCollection(): AngularFirestoreCollection {
    return this.deliveryOptionService.getCollection()
  }

  public updateDeliveryOption(deliveryOption: DeliveryOption, id: any) {
    return this.updateDeliveryOption(deliveryOption, id)
  }

  public addDeliveryOption(deliveryOption: DeliveryOption): Promise<DocumentReference> {
    return this.deliveryOptionService.addDeliveryOption(deliveryOption)
  }

  public deleteDeliveryOption(optionId: string) {
    if (optionId) {
      return this.getCollection().doc(optionId).delete().then(() => { return true });
    }
    return false;
  }

  public convertValuesToString(dataItem: any, key: string): string {
    switch (key) {
      case "price":
        return new CurrencyPipe("en-US").transform(dataItem[key], "USD");
      default:
        return dataItem[key];
    }
  }
}